@if (route.data | async) {
    <router-outlet></router-outlet>
} @else {
    <div class="flex flex-col gap-4 m-16 justify-center items-center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
}

